import { registerPhoneNumberRevealListener } from "@modules/single-page/crawler-protection/phone-number"
import { getNonce } from "@modules/util/nonce"

registerPhoneNumberRevealListener(getNonce("phoneNumberNonce"))
